import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ErrorStateMatcher } from '../state-matcher';

import { LabelDirective } from './label.directive';
import { FormFieldComponent } from './form-field.component';
import { FormFieldErrorDirective } from './form-field-error.directive';
import { ControlStatusDirective } from './control-status.directive';

@NgModule({
  exports: [
    ControlStatusDirective,
    FormFieldComponent,
    FormFieldErrorDirective,
    LabelDirective,
  ],
  imports: [
    CommonModule,
    ControlStatusDirective,
    FormFieldComponent,
    FormFieldErrorDirective,
    LabelDirective,
  ],
  providers: [
    ErrorStateMatcher,
  ],
})
export class FormFieldModule {}
